<template>
    <div>
        <div :dir="localDisplayLang === 'ara' ? 'rtl' : 'ltr'" id="homeApp">
            <div class="firest_block">
                <div class="app_logo">
                    <img src="@/assets/icons/app_logo.png" width="90%" alt="AppLogo">
                </div>
                <div class="login_viewcontent">
                    <div class="login_button">
                        <button class="button-primary" @click="goLogin">
                            {{ $t("LOGIN") }}
                        </button>
                    </div>
                    <div class="view_content">
                        <button class="button-primary" @click="goHome">
                            {{ $t("Browse only") }}
                        </button>
                    </div>
                </div>
                <div class="forgot_password" v-if="appConfig.featureEnabled.isForgetPasswordFlag">
                    <p>
                        <span> {{ $t("Forgot your password") }} </span> <span class="recover">| <span @click="getItBack"></span>{{ $t("Get it back") }}
                        </span>
                    </p>
                </div>
            </div>
            <div class="register_block">
                <div class="register">
                    <button class="button-primary" @click="actShowRegister">
                        {{ $t("Register") }}
                    </button>
                </div>
            </div>
        </div>
        <div class="register-popup blurred" v-if="registerPopupShow">
            <div class="register-popup-content">
                <div class="register-popup-header">
                    <div class="register-popup-title">
                        {{ $t("Activate your access!") }}
                    </div>
                </div>
                <div class="register-popup-body">
                    <div class="register-popup-text">
                        {{ $t("Register line one") }}
                    </div>
                    <div class="register-popup-text">
                        {{ $t("Register line two") }}
                    </div>
                </div>
                <div class="register-popup-footer">
                    <button class="button-primary" @click="redirectToMicuenta">
                        {{ $t("Close") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from "@/eventBus";
import { mapGetters, mapMutations } from "vuex";
import { _providerId, _projectName } from "@/provider-config.js";
import Redirection from "@/mixins/redirection.js";

export default {
    props: {
        callBack: {
            type: Function,
        },
    },
    data() {
        return {
            date: new Date(),
            registerPopupShow: false,
            localDisplayLang: null
        };
    },
    watch: {
    },
    computed: {
        ...mapGetters(["appConfig", "getRtl"])
    },
    created() {
    },
    mounted() {
        this.appVersion = this.appConfig.appPlatform.appVersion;
        this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
        this.localDisplayLang = this.localDisplayLang == 'eng' ? 'en' : this.localDisplayLang;
    },
    methods: {
        ...mapMutations(["setRtl"]),
        actShowRegister() {
            this.registerPopupShow = true;
            // this.callBack();
        },
        goLogin() {
            this.redirectToLogin(this.localDisplayLang);
            this.callBack();
        },
        goHome() {
            this.callBack();
        },
        redirectToMicuenta() {
            this.registerPopupShow = false
            // window.open("https://micuentastg.mvshub.com.ar/", "_self");
            // https://micuentastg.mvshub.com.ar/mi-cuenta?data=<id Token>
        },
        getItBack() {
            window.open("https://micuentastg.mvshub.com.ar/", '_blank');
        }

    },
    components: {},
    mixins: [Redirection],
};
</script>

<style lang="scss">
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";

#homeApp {
    margin: 5rem auto;
    max-width: 480px;
    width: 85%;
    display: flex;
    flex-direction: column;
    gap: 5rem;
    align-items: center;
    justify-content: center;

    .firest_block {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        align-items: center;
        justify-content: center;
        width: 100%;

        .app_logo {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .login_viewcontent {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 0.8rem;

            .login_button,
            .view_content {
                width: 90%;
            }
        }

        .forgot_password {
            margin: 2rem 0;

            .recover {
                color: chocolate;
                cursor: pointer;
            }
        }
    }

    .register_block {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        align-items: center;
        justify-content: center;
        width: 100%;

        .register {
            width: 90%;

            .button-primary {
                background-color: rgb(30, 30, 30);
                color: #ffffff;
            }
        }
    }

    .button-primary {
        padding: 1.3rem 1rem;
        width: 100%;
        border-radius: 0.5rem;
        font-size: 1rem;
    }
}

.register-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #212121;
    //opacity: 0.9;
    z-index: 999999999;
    display: flex;
    align-items: center;
    justify-content: center;

    .register-popup-content {
        padding: 2rem;
        border: 1px solid #222222;
        background: #e1e1e1;
        max-width: 600px;
        width: 35%;
        min-width: 320px;
        color: #000000;
        border-radius: 0.5rem;

        .register-popup-header {
            text-align: center;
            .register-popup-title {
                font-size: 1.5rem;
                font-weight: bold;
            }
        }

        .register-popup-body {
            padding: 2rem 1rem;
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }

        .register-popup-footer {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 1rem;

            .register-popup-btns {
                border-radius: 8px;
                background-color: #999;
                padding: 1rem 2rem;
                font-weight: bold;
                font-size: clamp(0.5rem, 2vw, 1rem);
                text-align: center;
                cursor: pointer;

                &:hover {
                    transform: scale(1.05);
                }
            }

            .button-primary {
                max-width: 70%;
                font-size: 1rem;
                &:hover {
                    background-color: $primary-btn-color;
                    color: $clr-primary-button-common;
                }
            }
        }
    }
}


</style>